var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreatmentFollowup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.368,
    height: 12,
    viewBox: "0 0 10.368 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(2.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2720",
    "data-name": "Path 2720",
    d: "M154.647,0A2.345,2.345,0,0,0,152.3,2.343V3.557a2.343,2.343,0,1,0,4.685,0V2.343A2.345,2.345,0,0,0,154.647,0Z",
    transform: "translate(-152.304)",
    fill: "#0abb94"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(0 6.291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2721",
    "data-name": "Path 2721",
    d: "M44.362,264.569a5.947,5.947,0,0,0-3.379-2.669.094.094,0,0,0-.094.023,9.792,9.792,0,0,1-1.7,1.289,12.182,12.182,0,0,1-1.7-1.289.094.094,0,0,0-.094-.023,5.945,5.945,0,0,0-3.379,2.669.094.094,0,0,0,0,.095,6.015,6.015,0,0,0,10.342,0A.093.093,0,0,0,44.362,264.569Zm-1.982.7a.1.1,0,0,1-.1.091h-.635a.109.109,0,0,0-.108.1v.656a.08.08,0,0,1-.079.091h-.57a.1.1,0,0,1-.1-.091v-.656a.091.091,0,0,0-.087-.1h-.662a.092.092,0,0,1-.095-.091V264.7a.094.094,0,0,1,.095-.093H40.7a.089.089,0,0,0,.087-.094v-.657a.1.1,0,0,1,.1-.092h.564a.086.086,0,0,1,.086.092v.659a.1.1,0,0,0,.1.092h.641a.1.1,0,0,1,.1.1Z",
    transform: "translate(-34.007 -261.896)",
    fill: "#0abb94"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatmentFollowup);
export default __webpack_public_path__ + "static/media/treatment_followup.d60f87e40cbcbc8ac6a3c337322439a4.svg";
export { ForwardRef as ReactComponent };